.b9{aspect-ratio:1/1;}